import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconTypes } from '@shared/v2/models';
import { SdvorIconComponent } from '../../icon';

@Component({
  selector: 'sd-dropdown-toggler',
  templateUrl: './dropdown-toggler.component.html',
  styleUrls: ['./dropdown-toggler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorIconComponent],
})
export class DropdownTogglerComponent {
  hideArrow = input(false);

  iconTypes = IconTypes;
}
